// src/utils/themeConfig.js

export const themes = {
  default: {
    name: 'Default',
    description: 'Classic blue theme',
    colors: {
      primary: '#1890ff',
      secondary: '#096dd9',
      pageBackground: '#f8f9fa',
      cardBackground: '#ffffff',
      activeBackground: '#e6f7ff',
      danger: '#ff4d4f',
      hover: '#40a9ff',
      dangerHover: '#ff7875',
      warning: '#fa8c16',
      sidebarBackground: '#ffffff',
      activeText: '#1890ff',
      hoverText: '#ffffff',
      text: '#262626',
      border: '#f0f0f0',
      logoBackground: '#ffffff',
      helpBackground: '#ffffff',
      profileBackground: '#ffffff',
      disabledBackground: '#8e9490',
      disabledText: '#ffffff'
    }
  },
  
  'forest-green': {
    name: 'Nadaa X - Forest Green',
    description: 'Natural green theme with earthy tones',
    colors: {
      primary: '#14281F',        // A - Primary buttons
      secondary: '#1F4034',      // B - Active text/fonts  
      pageBackground: '#64817D', // C - Main page background
      cardBackground: '#CCDCDD', // D - Cards & sidebar background
      activeBackground: '#FCA26E', // E - Active sidebar items background
      danger: '#F5751D',         // F - Delete buttons
      hover: '#345446',          // General hover states
      dangerHover: '#f58c45',    // Hover states for delete button
      warning: '#FCA26E',        // Warning/secondary elements
      sidebarBackground: '#CCDCDD', // D - Sidebar background
      activeText: '#1F4034',     // B - Active text color
      hoverText: '#ffffff',      // White text on hover
      text: '#14281F',           // Dark text
      border: '#64817D',         // Border color
      logoBackground: '#CCDCDD', // D - Logo background
      helpBackground: '#CCDCDD', // D - Help section background
      profileBackground: '#CCDCDD', // D - Profile background
      disabledBackground: '#8e9490', // Darker gray for disabled buttons
      disabledText: '#ffffff'    // White text for disabled buttons
    }
  },

  salesforce: {
    name: 'Enterprise Blue',
    description: 'A sophisticated business theme featuring dependable blue and strategic accents',
    colors: {
      primary: '#0176d3',        // Salesforce blue
      secondary: '#032d60',      // Dark blue
      pageBackground: '#f3f2f2', // Light gray
      cardBackground: '#ffffff', // White cards
      activeBackground: '#0176d3', // Active blue
      danger: '#ea001e',         // Salesforce red
      hover: '#014486',          // Darker blue hover
      dangerHover: '#c9001a',    // Darker red hover
      warning: '#fe9339',        // Salesforce orange
      sidebarBackground: '#ffffff', // White sidebar
      activeText: '#ffffff',     // White text on active
      hoverText: '#ffffff',      // White text on hover
      text: '#080707',           // Almost black
      border: '#dddbda',         // Light border
      logoBackground: '#ffffff', // White logo background
      helpBackground: '#ffffff', // White help background
      profileBackground: '#ffffff', // White profile background
      disabledBackground: '#8e9490', // Darker gray for disabled buttons
      disabledText: '#ffffff'    // White text for disabled buttons
    }
  }
};

export const defaultTheme = 'default';

export const getTheme = (themeName) => {
  return themes[themeName] || themes[defaultTheme];
};

export const getThemeNames = () => {
  return Object.keys(themes);
};